var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { LocalhostFromObject, SplitFactory } from "@splitsoftware/splitio-browserjs";
import shajs from "sha.js";
function experimentsReady() {
  var _a;
  return ((_a = window.experiments) == null ? void 0 : _a.isReady) || void 0;
}
function getUserConsent() {
  var _a;
  return (_a = window.experiments) == null ? void 0 : _a.UserConsent.getStatus();
}
function getVariation(flagName, attributes) {
  var _a;
  return (_a = window.experiments) == null ? void 0 : _a.clientInstance.getTreatment(flagName, attributes);
}
function getVariationWithConfig(flagName, attributes) {
  var _a;
  return (_a = window.experiments) == null ? void 0 : _a.clientInstance.getTreatmentWithConfig(flagName, attributes);
}
const hashString = (data) => data ? shajs("sha256").update(data).digest("hex") : "";
function loadExperiments(clientId, apiKey, options = {}) {
  if (window.experiments) {
    window.experiments.clientInstance.destroy();
  }
  let authKey = apiKey;
  let isEnabled = true;
  const clientOptions = options;
  const localhostKey = "localhost";
  const urlParams = new URLSearchParams(window.location.search);
  const localhostParams = urlParams.get("jcUiExperiments");
  const localhostFeatures = /* @__PURE__ */ new Map();
  if (localhostParams && localhostParams === "disabled") {
    isEnabled = false;
  } else if (localhostParams) {
    authKey = localhostKey;
    localhostParams.toString().split(",").forEach((item) => {
      const keyValuePair = item.split(":");
      if (keyValuePair.length === 2) {
        localhostFeatures.set(keyValuePair[0], keyValuePair[1]);
      } else {
        throw new Error("Cannot read feature flag name or variation name. Please make sure URL parameter follows this pattern: ?jcUiExperiments=flagName:variationName");
      }
    });
    clientOptions.features = Object.fromEntries(localhostFeatures);
  }
  if (authKey === localhostKey) {
    clientOptions.sync = {
      localhostMode: LocalhostFromObject()
    };
  }
  if (isEnabled) {
    const splitFactory = SplitFactory(__spreadValues({
      core: {
        authorizationKey: authKey,
        key: hashString(clientId)
      }
    }, clientOptions));
    window.experiments = splitFactory;
    window.experiments.clientInstance = splitFactory.client();
    window.experiments.isReady = false;
    window.experiments.clientInstance.on(window.experiments.clientInstance.Event.SDK_READY, function() {
      window.experiments.isReady = true;
    });
  }
}
function setUserConsent(isGranted) {
  var _a;
  return (_a = window.experiments) == null ? void 0 : _a.UserConsent.setStatus(isGranted);
}
function trackEvent(trafficType, eventType, eventValue, properties) {
  var _a;
  return (_a = window.experiments) == null ? void 0 : _a.clientInstance.track(trafficType, eventType, eventValue, properties);
}
export {
  experimentsReady,
  getUserConsent,
  getVariation,
  getVariationWithConfig,
  loadExperiments,
  setUserConsent,
  trackEvent
};
